import PremiereIcon from 'assets/icons/premiere-logo.svg';
import { PropsExport } from '.';
import { EExportName, EExportSubData } from 'ts/enums';

const subDataRender = [
  {
    key: EExportSubData.MARKERS,
    title: 'Markers',
    option: { onlyBookmarks: false },
    allowMultipleMedia: true
  },
  {
    key: EExportSubData.CAPTION_SUBTITLES,
    title: 'Captions/Subtitles',
    option: { withGapless: false },
    allowMultipleMedia: true
  }
];

export function PremiereExport({ exportOption, setExportOption }: PropsExport) {
  return (
    <div className="premirere-export export-item">
      <div className="d-flex flex-column justify-content-center align-items-center cursor-pointer"
        onClick={() => {
          setExportOption(draft => {
            draft.key = EExportName.PREMIERE_PRO;
            draft.data.subData = subDataRender[0].key;
            draft.data.option = subDataRender[0].option;
            draft.allowMultipleMedia = subDataRender[0].allowMultipleMedia;
          })
        }}>
        <div
          className={`icon ${exportOption.key === EExportName.PREMIERE_PRO ? 'opacity-100' : 'opacity-50'
            }`}
        >
          <img src={PremiereIcon} alt="" />
        </div>
        <div
          className={`text mt-1 ${exportOption.key === EExportName.PREMIERE_PRO ? '--selected' : ''
            }`}
        >
          <span>Adobe Premiere Pro</span>
        </div>
      </div>
      <div
        className={`text mt-1 ${exportOption.key === EExportName.PREMIERE_PRO ? '--selected' : ''
          }`}
      >
        {exportOption.key === EExportName.PREMIERE_PRO && (
          <div className="choose-option mt-2">
            {subDataRender.map((s) => (
              <label className="d-flex align-items-center mb-1 gap-1 cursor-pointer" key={s.key}>
                <input
                  type="radio"
                  name="select"
                  defaultChecked={s.key === EExportSubData.MARKERS}
                  onClick={() => {
                    setExportOption(draft => {
                      draft.key = EExportName.PREMIERE_PRO;
                      draft.data.subData = s.key;
                      draft.data.option = s.option;
                      draft.allowMultipleMedia = s.allowMultipleMedia;
                    })
                  }}
                />
                <span>{s.title}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
